import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Container, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import RHFTextArea from '../../components/hook-form/RHFTextArea';
import { useLoadingContext } from '../../context/loadingContext';
import { MemberService } from '../../Services/member.service';
import { CKEditorComponent } from '../CKEditor';

const EditMemberNotes = () => {
  const navigate = useNavigate();
  const [note, setNote] = useState('');
  const { handleStartLoading, handleStopLoading } = useLoadingContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleCancelClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    (async () => {
      try {
        handleStartLoading();
        const data = await MemberService.GetMemberNotes();
        setNote(data.description);
      } catch (e) {
        console.log(e.response.data);
      } finally {
        handleStopLoading();
      }
    })();
  }, []);

  const handleEditNote = () => {
    MemberService.EditMemberNotes({
      description: note,
    })
      .then(() => {
        navigate('/member', { replace: true, state: '/member' });
        enqueueSnackbar('Cập nhật thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading);
  };

  return (
    <Page title="Create event">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cập nhật chi tiết chương trình
          </Typography>
          <Stack direction={'row'} spacing={1}>
            <Button
              type="button"
              onClick={handleCancelClick}
              color="error"
              variant="contained"
              startIcon={<Iconify icon="iconoir:cancel" />}
            >
              Hủy
            </Button>
            <Button onClick={handleEditNote} type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
              Lưu
            </Button>
          </Stack>
        </Stack>
        <CKEditorComponent placeholder={'Ghi chú'} onValueChange={setNote} value={note} />
      </Container>
    </Page>
  );
};

export default EditMemberNotes;
